// extracted by mini-css-extract-plugin
export default {"actionsContainer":"MessageActions_actionsContainer__EF82J","actionsBar":"MessageActions_actionsBar__kVt-0","actionButton":"MessageActions_actionButton__zDY5q"};